export default "__VITE_ASSET__02d4bf27__"